// import http from '../api/http'

const retailDashRoutes = [
  {
    path: "retail",
    name: "MainRetailDashboard",
    meta:{
      auth: true,
      translated: "Dashboard",
      permission: { act: "create", on: "DoneForm" },
    },
    component: () => import("./components/index/MainIndex.vue"),
    children: [
      {
        path: "spark",
        name: "SparkLines",
        meta:{
          auth: true,
          translated: "Dashboard",
          permission: { act: "create", on: "DoneForm" },
        },
        component: () => import("./components/index/sparkline/MainSparkline.vue"),
      },
      {
        path: "comparison",
        name: "DeptCompare",
        meta:{
          auth: true,
          translated: "Dashboard",
          permission: { act: "create", on: "DoneForm" },
        },
        component: () => import("./components/index/dept_compare/DeptCompare.vue"),
      },
      {
        path: "raking",
        name: "DeptRanking",
        meta:{
          auth: true,
          translated: "Dashboard",
          permission: { act: "create", on: "DoneForm" },
        },
        component: () => import("./components/index/dept_ranking/DepartmentRanking.vue"),
      },
      {
        path: "fails",
        name: "FailDashboard",
        meta:{
          auth: true,
          translated: "Dashboard",
          permission: { act: "create", on: "DoneForm" },
        },
        component: () => import("./components/index/failures/FailsDashboard.vue"),
      },
      {
        path: "by_users",
        name: "ReportByUser",
        meta:{
          auth: true,
          translated: "Dashboard por usuários",
          permission: { act: "create", on: "DoneForm" },
        },
        component: () => import("./components/index/by_users/ReportByUsers.vue"),
      },
      {
        path: "action_plan",
        name: "ActionPlanDashboard",
        meta:{
          auth: true,
          translated: "Dashboard de planos de ação",
          permission: { act: "create", on: "DoneForm" },
        },
        component: () => import("./components/index/action_plan/ActionPlanDashboard.vue"),
      },
    ]
  },
  {
    path: "/retail/dashboard/:dep_id",
    name: "RetailDeptDashboard",
    meta:{
      auth: true,
      translated: "Dashboard",
      permission: { act: "create", on: "DoneForm" },
    },
    component: () => import("./components/show/department/MainDeptShowDashboard.vue"),
    children: [
      {
        path: "forms",
        name: "DeptFormCompare",
        meta:{
          auth: true,
          translated: "Dashboard",
          permission: { act: "create", on: "DoneForm" },
        },
        component: () => import("./components/show/department/form_compare/DeptFormCompare.vue"),
      },
      {
        path: "historic",
        name: "DeptFormHistoric",
        meta:{
          auth: true,
          translated: "Dashboard",
          permission: { act: "create", on: "DoneForm" },
        },
        component: () => import("./components/show/department/historic/DeptoFormsHistoric.vue"),
      },
      {
        path: "done_forms",
        name: "DeptDoneForms",
        meta:{
          auth: true,
          translated: "Dashboard",
          permission: { act: "create", on: "DoneForm" },
        },
        component: () => import("./components/show/department/done_forms/DeptDoneForms.vue"),
      },
    ]
  },
];

export default retailDashRoutes;